export const getTestIdSuffixForNavElement = (navElement) => {
    const { url, label } = navElement;
    return url ? url.split('/').join('-') : `-${label.toLowerCase().split(' ').join('-')}`;
};
export const createTestId = (name, isVisible) => `${name}${isVisible ? '-open' : ''}`;
//# sourceMappingURL=utils.js.map